<!-- 评价 -->
<template>
  <div class="zlr-evaluate">
    <ul>
      <li v-for="(item,index) in label"
          :key="index"
          @click="handleClick(index)"
          @mouseover="mouverOverHover(index)"
          @mouseleave="mouseLeaveHover(index)"
          :class="{active: index+1 === value}">
        <Icon type="ios-star"
              :size="24"
              :color="(index+1<=value || index+1<=hoverIndex)? '#ffa940':'#bfbfbf'" />
        <p>{{item}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: Array,
      default () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      hoverIndex: 0
    }
  },
  computed: {},
  mounted () { },
  methods: {
    handleClick (index) {
      if (this.disabled) return false
      this.$emit('input', index + 1)
      this.$emit('on-change', index + 1)
    },
    mouverOverHover (index) {
      this.hoverIndex = index + 1
    },
    mouseLeaveHover (index) {
      this.hoverIndex = 0
    }
  }
}
</script>
<style lang="less" scoped>
.zlr-evaluate {
  > ul {
    line-height: 1;
    > li {
      display: inline-block;
      width: 96px;
      margin-right: 12px;
      text-align: center;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      p {
        margin-top: 4px;
        color: #bfbfbf;
        line-height: 18px;
        font-size: 12px;
        height: 18px;
      }
      &.active {
        animation-duration: 0.5s;
        animation-fill-mode: both;
        animation-name: enlarge;
        p {
          color: #ffa940;
        }
      }
    }
  }
}
@keyframes enlarge {
  0% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
